// This file is auto-generated. Do not edit directly.
export const DEPLOYMENT_URL = 'https://staging.blumint.io' as const;
